const React = require( 'react' );
import PropTypes from 'prop-types';

import { Spin } from '@nackle/paper';
require( './loading-overlay.less' );


const LoadingOverlay = ( props ) => {


        return (
                <Spin
                    wrapperClassName="spinner"
                    size="large"
                    spinning={ props.loading }
                >{ props.children }</Spin>
        );
    };
    export default LoadingOverlay;

    LoadingOverlay.propTypes = {
        loading: PropTypes.bool
    };
